import { render } from "./TradingOverlay.vue?vue&type=template&id=368f264a&scoped=true&ts=true"
import script from "./TradingOverlay.vue?vue&type=script&lang=ts"
export * from "./TradingOverlay.vue?vue&type=script&lang=ts"

import "./TradingOverlay.vue?vue&type=style&index=0&id=368f264a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-368f264a"]])

export default __exports__